import styled from 'styled-components';
import { styled as materialStyled } from '@material-ui/core/styles';
import { Button as MaterialButton } from '@material-ui/core';
import backgroundSource from '../../../images/app-background.svg';

export const BlurredBackgroundImage = styled.main`
  /* We need to set position to fixed so we can apply the filter
   only on the bg image */
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${backgroundSource});
  filter: blur(8px);
  -webkit-filter: blur(8px);
`;

export const PublicRouteWrapper = styled.main`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .selector {
    display: flex;
    flex-direction: row;
  }
`;

export const PrivateRouteWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: column;

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Logo = styled.img`
  display: flex;
  margin: auto;
  max-height: 40px;
`;

// export const Button = materialStyled(MaterialButton)({
//   background: '#f76d31',
//   height: '40px',
//   fontSize: '16px',
//   color: 'white',
//   '&:hover': {
//     background: '#f76d31',
//   },
// });
